import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#041e42',
                secondary: '#51534a',
                tertiary: '#b1c9e8',
                accent: '#b9975b'
            },
            dark: {

            }
        }
    }
});
